import {
  Badge, Box, Tabs, Text,
} from '@usealloy/component-library';
import { ExternalAccountCreatedOverview } from './ExternalAccountCreatedOverview';
import type { CoreRiskData } from '../../RiskRatingCard/useRiskData';
import { RiskRatingCard } from '../../RiskRatingCard/RiskRatingCard';
import { useEventTypeEvaluationsContext } from '../context';

interface ExternalAccountCreatedTabsProps {
  riskData: CoreRiskData;
  canViewRiskFormula: boolean;
}

export const ExternalAccountCreatedTabs = ({
  riskData,
  canViewRiskFormula,
}: ExternalAccountCreatedTabsProps) => {
  const { evaluation } = useEventTypeEvaluationsContext();
  const {
    riskFactors, riskFormula, riskRangeValues, totalRisk, riskRatingColor, riskRatingLabel,
  } = riskData;

  const tabs = [
    {
      label: 'Overview',
      value: 'overview',
      content: <ExternalAccountCreatedOverview />,
    },
    {
      label: (
        <Box>
          <Text style={{ color: 'var(--cl-text-secondary)' }}>Risk Score</Text>
          { riskRatingColor && riskRatingLabel && (
            <Badge outline backgroundColor={riskRatingColor}>{riskRatingLabel}</Badge>
          )}
        </Box>
      ),
      value: 'risk-score',
      content: (
        <RiskRatingCard
          canViewRiskFormula={canViewRiskFormula}
          entityToken={evaluation.entity_token}
          evaluationToken={evaluation.evaluation_token}
          evaluationType={evaluation.evaluation_type}
          riskFactors={riskFactors}
          riskOutputFormula={riskFormula}
          riskRanges={riskRangeValues}
          riskValue={totalRisk}
          riskValueColor={riskRatingColor}
          riskValueLabel={riskRatingLabel}
          variant="entityRisk"
          workflowToken={evaluation.application_token}
          workflowVersion={evaluation.public_version}
        />
      ),
    },
  ];

  return (
    <Tabs style={{ width: '100%' }} tabs={tabs} />
  );
};
